import React from 'react';
import { useForm } from 'react-hook-form';
import { motion } from 'framer-motion';
import { Loader2Icon } from 'lucide-react';
import axios from 'axios';
interface RegisterFormProps {
  onSuccess: () => void;
}
type FormData = {
  nombre: string;
  email: string;
};
export const RegisterForm: React.FC<RegisterFormProps> = ({
  onSuccess
}) => {
  const {
    register,
    handleSubmit,
    formState: {
      errors,
      isSubmitting
    }
  } = useForm<FormData>();
  const onSubmit = async (data: FormData) => {
    try {
      // Guardar en localStorage como respaldo
      const registrations = JSON.parse(localStorage.getItem('registrations') || '[]');
      const newRegistration = {
        ...data,
        fecha: new Date().toISOString(),
        id: Date.now()
      };
      registrations.push(newRegistration);
      localStorage.setItem('registrations', JSON.stringify(registrations));
      // Enviar a Zapier
      const response = await axios.post('https://hooks.zapier.com/hooks/catch/17936474/u84og5x/', {
        name: data.nombre,
        email: data.email,
        timestamp: new Date().toISOString()
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (response.status === 200) {
        onSuccess();
      } else {
        throw new Error('Error al enviar a Zapier');
      }
    } catch (error) {
      console.error('Error al procesar el registro:', error);
      // Aún así llamamos onSuccess porque los datos se guardaron en localStorage
      onSuccess();
    }
  };
  return <form onSubmit={handleSubmit(onSubmit)} className="space-y-4" data-id="element-159">
      <div data-id="element-160">
        <label htmlFor="nombre" className="block text-sm font-medium text-gray-300 mb-1" data-id="element-161">
          Nombre completo
        </label>
        <input id="nombre" type="text" placeholder="Tu nombre completo" className={`w-full px-4 py-3 bg-gray-800/50 border ${errors.nombre ? 'border-red-500' : 'border-gray-700'} rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500`} {...register('nombre', {
        required: 'El nombre es obligatorio'
      })} data-id="element-162" />
        {errors.nombre && <p className="mt-1 text-sm text-red-500" data-id="element-163">{errors.nombre.message}</p>}
      </div>
      <div data-id="element-164">
        <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-1" data-id="element-165">
          Correo electrónico
        </label>
        <input id="email" type="email" placeholder="tucorreo@ejemplo.com" className={`w-full px-4 py-3 bg-gray-800/50 border ${errors.email ? 'border-red-500' : 'border-gray-700'} rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500`} {...register('email', {
        required: 'El correo electrónico es obligatorio',
        pattern: {
          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
          message: 'Dirección de correo electrónico inválida'
        }
      })} data-id="element-166" />
        {errors.email && <p className="mt-1 text-sm text-red-500" data-id="element-167">{errors.email.message}</p>}
      </div>
      <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} type="submit" disabled={isSubmitting} className="w-full py-3 px-4 bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 rounded-lg font-bold text-white shadow-lg shadow-purple-500/20 disabled:opacity-70 relative overflow-hidden" data-id="element-168">
        {isSubmitting ? <span className="flex items-center justify-center" data-id="element-169">
            <Loader2Icon className="animate-spin mr-2" size={18} data-id="element-170" />
            Enviando...
          </span> : 'Asegurar mi lugar ahora'}
      </motion.button>
      <p className="text-xs text-gray-400 text-center" data-id="element-171">
        Al registrarte, aceptas nuestra Política de Privacidad y Términos y
        Condiciones.
      </p>
    </form>;
};